// Polyfill para Array.prototype.at
import 'core-js/actual/array/at';

import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material';
import theme from './theme';

function noop() { }

if (process.env.NODE_ENV !== 'development') {
    console.log = noop;
    console.warn = noop;
    console.error = noop;
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles
            styles={{
                body: { backgroundColor: '#F0F6EB' },
                a: { color: '#000000DE', textDecoration: 'none' },
                'a:hover': { textDecoration: 'underline' },
            }}
        />
        {/* <React.StrictMode> */}
        <App />
        {/* </React.StrictMode> */}
    </ThemeProvider>
);